// frontend/src/components/mcbim/WelcomeFloorPicker.tsx
import { Box, Center, Stack, Text, ThemeIcon, Paper } from "@mantine/core";
import { MdLayers } from "react-icons/md";
import { BuildingStoryList } from "./LeftSidebar/BuildingStoryList";

export const WelcomeFloorPicker: React.FC = () => {
  return (
    <Center
      h="100%"
      w="100%"
      style={{
        overflow: "hidden",
        padding: 24,
      }}
    >
      <Paper
        radius="md"
        withBorder
        shadow="sm"
        style={{
          width: "33%",
          minWidth: 320,
          maxWidth: 520,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          paddingTop: 40,
          paddingLeft: 18,
          paddingRight: 18,
          paddingBottom: 14,
          background: "var(--mantine-color-white)",
        }}
      >
        <Center>
          <Stack align="center" gap={8}>
            <ThemeIcon size={60} radius="xl" variant="light" color="blue">
              <MdLayers size={32} />
            </ThemeIcon>

            <Text fw={700} size="xl" ta="center">
              Velkommen til prosjektet
            </Text>

            <Text size="sm" c="dimmed" ta="center" maw={320}>
              Velg en etasje for å starte. Du kan når som helst bytte etasje i listen.
            </Text>
          </Stack>
        </Center>

        <Box style={{ flex: 1, minHeight: 0, marginTop: 20 }}>
          <BuildingStoryList />
        </Box>
      </Paper>
    </Center>
  );
};
